export enum GenderEnum {
  NOT_SET = 0,
  MALE = 1,
  FEMALE = 2,
  NEUTRAL = 3,
}

export enum MateType {
  Original = 1,
  Fanswork = 2,
  User = 3,
  SelfAvatar = 4,
}

export enum MateSearchableFields {
  NAME = "name",
  NAME_CHINESE = "nameChinese",
  NAME_ENGLISH = "nameEnglish",
  BIO = "bio",
  BIO_CHINESE = "bioChinese",
  BIO_ENGLISH = "bioEnglish",
  TAG = "tag",
}

export enum AdoptionStatus {
  Available = 1,
  Adopted = 2,
  Unlisted = 3,
}

export enum MateAdoptionStatus {
  NeverAdopted = 1,
  Available = 2,
  Adopted = 3,
}

export enum MateMailType {
  Inbox = "inbox",
  Sent = "sent",
  Read = "read",
  Unread = "unread",
  Draft = "draft",
  Trashed = "trashed",
  Replied = "replied",
  Unreplied = "unreplied",
  Threadbox = "threadbox",
}

export enum AIWriteType {
  MateMail = "mateMail",
  Roleplay = "roleplay",
  Module = "module",
  Reply = "reply",
  Moment = "moment",
}

export enum DispatchMemberType {
  Leader = 1,
  SelfCharacter = 2,
  OthersCharacter = 3,
}

export enum SettlementStatus {
  Unavailable = 1,
  Pending = 2,
  Settled = 3,
}

export enum DispatchMemberPayerType {
  Self = 1,
  Host = 2,
}

export enum ToneEmotion {
  Happy = 1,
  Sad = 2,
  Angry = 3,
  Fear = 4,
  Excited = 5,
  Coldness = 6,
  Neutral = 7,
  Surprised = 8,
  Hate = 9,
}

// memory
export enum MemoryType {
  Core = 1,
  Scene = 2,
}

export enum MemoryCapacityLevel {
  Small = 1,
  Medium = 2,
  Large = 3,
}

export const MemoryCapacityLevelMap = {
  [MemoryType.Core]: {
    [MemoryCapacityLevel.Small]: 512,
    [MemoryCapacityLevel.Medium]: 768,
    [MemoryCapacityLevel.Large]: 1024,
  },
  [MemoryType.Scene]: {
    [MemoryCapacityLevel.Small]: 128,
    [MemoryCapacityLevel.Medium]: 256,
    [MemoryCapacityLevel.Large]: 512,
  },
};

export const MemoryCapacityLevelCrystalMap = {
  [MemoryType.Core]: {
    [MemoryCapacityLevel.Small]: 0,
    [MemoryCapacityLevel.Medium]: 10,
    [MemoryCapacityLevel.Large]: 20,
  },
  [MemoryType.Scene]: {
    [MemoryCapacityLevel.Small]: 0,
    [MemoryCapacityLevel.Medium]: 5,
    [MemoryCapacityLevel.Large]: 10,
  },
};

export enum MemoryExtractionStatus {
  Extracting = 1,
  Failed = 2,
  Success = 3,
}

export enum DriftCapsuleRarity {
  Common = 1,
  Rare = 2,
  Epic = 3,
}

export enum DriftCapsuleStatus {
  Available = 1,
  Opened = 2,
}

export enum BillingCycle {
  Month = 1,
  Quarter = 2,
  Year = 3,
}

export enum MemberType {
  Free = 1,
  Standard = 2,
  Premium = 3,
  Basic = 4,
}

export enum PaymentMethod {
  Balance = 1,
  Stripe = 2,
  Alipay = 3,
  Wechat = 4,
  Crystal = 5,
}

export enum MemberSubscriptionStatus {
  Pending = 1,
  Active = 2,
  PastDue = 3,
  Canceled = 4,
}

// 用户任务状态枚举
export enum UserTaskStatus {
  IN_PROGRESS = "in_progress", // 进行中
  COMPLETED = "completed", // 已完成
  CLAIMED = "claimed", // 已领取奖励
}

// 任务类型枚举
export enum UserTaskType {
  DAILY = "daily", // 日常任务
  WEEKLY = "weekly", // 周任务
  ACTIVITY = "activity", // 活动任务
  MAINQUEST = "mainquest", // 主线任务
  SIDEQUEST = "sidequest", // 支线任务
}
